// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import LoadScript from 'containers/LoadScript'

class Content extends React.Component {
	componentDidMount() {
		this.load()
	}

	load() {
		if ( typeof IssuuReaders !== 'undefined' ) {
			IssuuReaders.add()
		}
	}

	render() {
		const { page } = this.props

		return (
			<div className="issuu-embed">
				<div data-configid="34210531/65928996" className="issuuembed"></div>

				<LoadScript
					src="https://e.issuu.com/embed.js"
					callback={ this.load }
				/>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Content )



// WEBPACK FOOTER //
// ./views/page/Magazine.jsx